import { ResourceHelperService } from "../resource-helper.service";

export class ChargeAccountAutoTopupService {
  public chargeAccountAutoTopupsResource: InterACT.Interfaces.IResource<InterACT.Interfaces.ChargeAccounts.AutoTopupsResponse>;
  public chargeAccountAutoTopupResource: InterACT.Interfaces.IResource<InterACT.Interfaces.ChargeAccounts.AutoTopupResponse>;
  constructor($resource, private resourceHelperService: ResourceHelperService) {
    this.chargeAccountAutoTopupsResource = $resource(
      'api/auto-topups',
      undefined,
      { update: { method: 'PUT' } });

    this.chargeAccountAutoTopupResource = $resource(
      'api/auto-topups/:autoTopupId',
      undefined,
      { update: { method: 'PUT' } });
  }

  /**
   * Retrieves list of Auto Topups
   *
   * @param page The number of the page of data to be retrieved
   * @param perPageCount The number of items per page to be retrieved
   * @param searchText The query to search for auto top up
   *
   * @returns A promise of a ChargeAccountAutoTopUpsResource
   */
  public getAutoTopups(page: number, perPageCount: number, searchText: string) {
    const options = this.resourceHelperService.buildRequestOptions(page, perPageCount, searchText);
    return this.chargeAccountAutoTopupsResource.get(options).$promise;
  }

  /**
   * Function to delete an auto top up rule
   *
   * @param autoTopupId the id of the auto top up to delete
   *
   * @returns A http promise object
   */
  public deleteAutoTopup(autoTopupId: string) {
    return this.chargeAccountAutoTopupResource.delete({ autoTopupId: autoTopupId }).$promise;
  }

  /**
   * Retrieves an Auto Topup
   *
   * @param id The id of the auto top up to retrieve
   *
   * @returns A promise of a ChargeAccountAutoTopUpResource
   */
  public getAutoTopup(id: string) {
    return this.chargeAccountAutoTopupResource.get({ autoTopupId: id }).$promise;
  }

  /**
   * Function to update a record from chargeAccount service
   *
   * @param autoTopupId The number of the cardId of data to be updated
   * @param data The auto topup data object to be sent in a PUT operation to the server
   *
   * @returns A http promise object
   */
  public updateAutoTopup(autoTopupId: string, data: InterACT.Interfaces.ChargeAccounts.ChargeAccount) {
    return (<any>this.chargeAccountAutoTopupResource).update({ autoTopupId }, data).$promise;
  }
}